import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '@/lib/auth-store';

export function ForbiddenPage() {
  const clear = useAuthStore((s) => s.clear);

  // 用户被守卫踢到 /403 时（角色非 ADMIN / SUPER_ADMIN 或 /auth/me 返回 403/5xx）
  // 必须立即清理会话，避免攻击者用篡改过的 localStorage 反复触达受保护路由。
  useEffect(() => {
    clear();
  }, [clear]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 px-6">
      <div
        className="max-w-md rounded-2xl bg-white p-8 text-center shadow"
        data-testid="forbidden-card"
      >
        <h1 className="text-2xl font-semibold text-slate-900">无权访问</h1>
        <p className="mt-3 text-sm text-slate-500">
          管理后台仅限管理员 / 超级管理员账号使用。若需查看个人通话与培训进度，请使用员工 APP。
        </p>
        <Link
          to="/login"
          className="mt-6 inline-flex rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600"
        >
          返回登录
        </Link>
      </div>
    </div>
  );
}
